// EXTERNAL
import { Auth } from "aws-amplify";

export default async function get_current_session() {
  const token = await Auth.currentSession();
  return token.idToken.jwtToken;
}
